export const dataContext = {
  namespaced: true,
  state: {
    dataContext: [],
    dataChangedIndex: 0,
    reviewDataSource: [],
    advanceFilterApplied: false,
    dataViewType: undefined,
    searchText: undefined,
    allowDataContext: true
  },
  actions: {
    async setDataContext({ commit }, payload) {
      commit("dataContext", payload);
    },
    setReviewDataSource({ commit }, payload) {
      commit('reviewDataSource', payload);
    },
    setAdvanceFilterApplied({ commit }, payload) {
      commit('advanceFilterApplied', payload);
    },
    setDataViewType({ commit }, payload) {
      commit('dataViewType', payload);
    },
    setSearchText({ commit }, payload) {
      commit('searchText', payload);
    },
    updateDataChangedIndex({ commit }, payload) {
      commit('updateDataChangedIndex', payload);
    },
    setAllowDataContext({ commit }, payload) {
      commit('allowDataContext', payload);
    },
  },
  mutations: {
    dataContext(state, payload) {
      if (state.allowDataContext) {
        state.dataContext[payload.key] = payload.value;
        state.dataChangedIndex += 1;
      }
    },
    resetDataChangedIndex(state) {
      state.dataChangedIndex = 0;
    },
    reviewDataSource(state, payload) {
      state.reviewDataSource = payload;
    },
    advanceFilterApplied(state, payload) {
      state.advanceFilterApplied = payload;
    },
    dataViewType(state, payload) {
      state.dataViewType = payload;
    },
    searchText(state, payload) {
      state.searchText = payload;
    },
    updateDataChangedIndex(state) {
      state.dataChangedIndex += 1;
    },
    allowDataContext(state, payload) {
      state.allowDataContext = payload;
    }
  },
  getters: {
    getDataContext: (state) => (key) => {
      // eslint-disable-next-line no-console
      // console.log("calling getDataContext", state.dataContext);
      return state.dataContext[key];
    },
    getReviewDataSource(state) {
      return state.reviewDataSource;
    },
    getAdvanceFilterApplied(state) {
      return state.advanceFilterApplied;
    },
    getDataViewType(state) {
      return state.dataViewType;
    },
    getSearchText(state) {
      return state.searchText;
    },
    getDataChangedIndex(state) {
      return state.dataChangedIndex;
    }
  },
};
